// reducers/index.ts
import { ActionReducerMap, combineReducers } from '@ngrx/store';

import * as fromProjects from './_features/projects/projects.reducer';
import * as fromProjectContent from './_features/projects/content/content.reducer';
import * as fromProfile from './_features/profile/profile.reducer';
// Course Related
// import * as fromCourse from './_features/products/course/course.reducer';
// import * as fromCourseItems from './_features/products/course/course-items/course-items.reducer';
// import * as fromCourseDetails from './_features/products/course/details/course-details.reducer';
// import * as fromCourseReports from './_features/products/course/reports/course-reports.reducer';

//Website Related



// Website State Combination

// Course State Combination
// export interface CourseCompoundState {
//   main: fromCourse.CourseState;
//   items: fromCourseItems.CourseItemState;
//   details: fromCourseDetails.CourseDetailsState;
//   reports: fromCourseReports.CourseReportsState
// }
// // Define reducers for the nested WebsiteState
// export const courseCompoundReducers = combineReducers({
//   main: fromCourse.courseReducer,
//   items: fromCourseItems.courseItemReducer,
//   details: fromCourseDetails.courseDetailsReducer,
//   reports: fromCourseReports.courseReportsReducer
// });

export interface ProjectCompoundState {
  main: fromProjects.ProjectState;
  items: fromProjectContent.ProjectContentState;
  // details: fromCourseDetails.CourseDetailsState;
  // students: fromCourseStudents.CourseStudentsState;
  // reports: fromCourseReports.CourseReportsState
}

export const projectCompoundReducers = combineReducers({
  main: fromProjects.projectsReducer,
  items: fromProjectContent.projectContentReducer
});


export interface AppState {
  
  projects: ProjectCompoundState;
  profile: fromProfile.ProfileState;
  // course: CourseCompoundState;
}

export const rootReducer: ActionReducerMap<AppState> = {
  projects: projectCompoundReducers,
  profile: fromProfile.profileReducer,
  // course: courseCompoundReducers,
};
